import { OrderListMassActionsEnum } from '../../../actions/utils/orderListMassActions';
import { SelectedOrderWithActions } from '../types/orderListMassActions.types';
import ApproveOrders from './ApproveOrders';
import ArchiveOrders from './ArchiveOrders';
import BackToApproved from './BackToApproved';
import BackToDraft from './BackToDraft';
import BackToInRevision from './BackToInRevision';
import BackToOnApproval from './BackToOnApproval';
import CancelOrders from './CancelOrders';
import ExportMultipleOrders from './ExportMultipleOrders';
import FinishToInRevision from './FinishToInRevision';
import FinishToOnApproval from './FinishToOnApproval';
import IOrderMassActionFactory from './IOrderMassActionFactory';
import MoveToSent from './MoveToSent';
import OrderMassAction from './OrderMassAction';
import SplitOrders from './SplitOrders';
import UnarchiveOrders from './UnarchiveOrders';
import UpdateConditions from './UpdateConditions';
import UpdatePrices from './UpdatePrices';
import CopyOrders from './copyOrders';
import CopyOrdersAsSuggested from './copyOrdersAsSuggested';

class OrderMassActionsFactory implements IOrderMassActionFactory {
  constructor(protected readonly orders: SelectedOrderWithActions[]) {}

  public create(orderListMassAction: OrderListMassActionsEnum): OrderMassAction {
    switch (orderListMassAction) {
      case OrderListMassActionsEnum.EXPORT_MULTIPLE_ORDERS:
        return new ExportMultipleOrders(this.orders);
      case OrderListMassActionsEnum.FINISH_TO_IN_REVISION:
        return new FinishToInRevision(this.orders);
      case OrderListMassActionsEnum.FINISH_TO_ON_APPROVAL:
        return new FinishToOnApproval(this.orders);
      case OrderListMassActionsEnum.APPROVE_ORDERS:
        return new ApproveOrders(this.orders);
      case OrderListMassActionsEnum.MOVE_TO_SENT:
        return new MoveToSent(this.orders);
      case OrderListMassActionsEnum.BACK_TO_DRAFT:
        return new BackToDraft(this.orders);
      case OrderListMassActionsEnum.BACK_TO_IN_REVISION:
        return new BackToInRevision(this.orders);
      case OrderListMassActionsEnum.BACK_TO_ON_APPROVAL:
        return new BackToOnApproval(this.orders);
      case OrderListMassActionsEnum.BACK_TO_APPROVED:
        return new BackToApproved(this.orders);
      case OrderListMassActionsEnum.CANCEL_ORDERS:
        return new CancelOrders(this.orders);
      case OrderListMassActionsEnum.ARCHIVE_ORDERS:
        return new ArchiveOrders(this.orders);
      case OrderListMassActionsEnum.UNARCHIVE_ORDERS:
        return new UnarchiveOrders(this.orders);
      case OrderListMassActionsEnum.UPDATE_PRICES:
        return new UpdatePrices(this.orders);
      case OrderListMassActionsEnum.UPDATE_CONDITIONS:
        return new UpdateConditions(this.orders);
      case OrderListMassActionsEnum.SPLIT_ORDERS:
        return new SplitOrders(this.orders);
      case OrderListMassActionsEnum.COPY_ORDERS:
        return new CopyOrders(this.orders);
      case OrderListMassActionsEnum.COPY_ORDERS_AS_SUGGESTED:
        return new CopyOrdersAsSuggested(this.orders);
      default:
        throw new Error(`Ação em massa ${orderListMassAction} não encontrada`);
    }
  }
}

export default OrderMassActionsFactory;
